var Config =  {
    Host: "https://www.captcha.eu",
    // Host: "https://hja-captcha.krone.at"
};
export default Config
